import { CredentialWithVerification } from 'types';
import { buildCredentialString } from './utils';
import { Box, useTheme } from '@mui/material';
import { ATSCredentialsWithVerificationTestIds } from 'data-testids/ATS';
import { BulletPoint } from 'ui-kit/icons';
import { VerifiedCredentialListItem } from './VerifiedCredential';
import { CredentialContentContainer, CredentialSummary } from './styles';
import { CredentialVerificationStatus } from 'utils/typedEnums';

export const CredentialRow: React.FC<{ credential: CredentialWithVerification }> = ({
  credential,
}) => {
  const isVerified =
    credential.verification_status === CredentialVerificationStatus.PASSED_AUTO_VERIFICATION ||
    credential.verification_status === CredentialVerificationStatus.PASSED_MANUAL_VERIFICATION;

  if (isVerified) {
    return <VerifiedCredentialListItem credential={credential} />;
  }

  return <UnverifiedCredentialListItem credential={credential} />;
};

const UnverifiedCredentialListItem: React.FC<{ credential: CredentialWithVerification }> = ({
  credential,
}) => {
  const theme = useTheme();
  const credentialString = buildCredentialString(credential);

  return (
    <Box data-testid={ATSCredentialsWithVerificationTestIds.CREDENTIAL_LIST_ITEM}>
      <CredentialContentContainer
        data-testid={ATSCredentialsWithVerificationTestIds.UNVERIFIED_CREDENTIAL}
      >
        <BulletPoint
          data-testid={ATSCredentialsWithVerificationTestIds.UNVERIFIED_BULLET_POINT}
          style={{ marginTop: theme.spacing(1) }}
        />
        <CredentialSummary
          data-testid={ATSCredentialsWithVerificationTestIds.CREDENTIAL_EXPLANATION}
        >
          {credentialString}
        </CredentialSummary>
      </CredentialContentContainer>
    </Box>
  );
};
